import * as React from "react";

var SpinnerIcon = require("@fortawesome/fontawesome-free/svgs/solid/spinner.svg");

export function WaitingSpinner(props) {
  if (props.waiting) {
    return /*#__PURE__*/React.createElement("div", {
      className: "waiting-spinner modal-container full"
    }, props.children, props.waiting && /*#__PURE__*/React.createElement("div", {
      className: "modal lighter full-screen"
    }, /*#__PURE__*/React.createElement("div", {
      className: "spin"
    }, /*#__PURE__*/React.createElement(SpinnerIcon, null))));
  } else {
    return props.children;
  }
}